import { create } from "zustand";

const useReleasePopupStore = create((set) => ({
  showPopup: false,
  release: null,

  setReleasePopup: (show, release) => set({ showPopup: show, release }),
  clearReleasePopup: () => set({ showPopup: false, release: null }),
}));

export default useReleasePopupStore;